import PanAnimation from "../logic/PanAnimation";
import WorldGrid from "../model/grid/WorldGrid";
import Vector from "../model/math/Vector";
import Selection from "../model/selection/Selection";
import Projection from "../Projection";
import { Settings } from "../Settings";
import UserInput from "./UserInput";

export default class InputHandler {
    /**
     * @param {UserInput} userInput 
     * @param {Projection} projection
     * @param {WorldGrid} worldGrid
     * @param {Selection} selection
     * @param {PanAnimation}
     */
    constructor(userInput, projection, worldGrid, panAnimation) {
        /**
         * @constant
         * @type {UserInput}
         */
        this.userInput = userInput;

        /**
         * @constant
         * @type {Projection}
         */
        this.projection = projection;

        /**
         * @constant
         * @type {WorldGrid}
         */
        this.worldGrid = worldGrid;

        /**
         * @constant
         * @type {PanAnimation}
         */
        this.panAnimation = panAnimation;

        /**
         * @type {boolean}
         */
        this.mapPanned = false;

        /**
         * @type {number}
         */
        this.mapPannedTime = 0;

        /**
         * @constant
         * @private
         * @type {Vector}
         */
        this.delta = new Vector(0, 0);

        /**
         * @constant
         * @private
         * @type {Vector}
         */
        this.screenCoordinate = new Vector(0, 0);
        /**
         * @constant
         * @private
         * @type {Vector}
         */
        this.clickWorldCoordinate = new Vector(0, 0);
        /**
         * @constant
         * @private
         * @type {Vector}
         */
        this.hoverWorldCoordinate = new Vector(0, 0);

        // /**
        //  * @constant
        //  * @private
        //  * @type {Array.<String>}
        //  */
        // this.jumpUp = [KeyCodes.UP_ARROW, KeyCodes.W];
        // /**
        //  * @constant
        //  * @private
        //  * @type {Array.<String>}
        //  */
        // this.moveLeft = [KeyCodes.LEFT_ARROW, KeyCodes.A];
        // /**
        //  * @constant
        //  * @private
        //  * @type {Array.<String>}
        //  */
        // this.moveRight = [KeyCodes.RIGHT_ARROW, KeyCodes.D];

    }   

    /**
     */
    handleInput() {
        if (this.userInput.leftMouseClick) {
            this.handleMouseClick();
        }
        else {
            ////////////////////////////////////////////
            // Panning
            ////////////////////////////////////////////

            this.handlePanning();

            ////////////////////////////////////////////
            // Zoom
            ////////////////////////////////////////////

            this.handleZoomInput();
        
        }
    }

    resetInputHandler() {
        // dont reset delta
        this.userInput.resetInputState();
    }

    /**
     * @private
     */
    handleMouseClick() {

        this.screenCoordinate.set(this.userInput.clickX, this.userInput.clickY);

        this.projection.screenToWorld(this.screenCoordinate, this.clickWorldCoordinate);   

        // // If the click is outside of the world grid, then ignore it.
        // if (!this.worldGrid.contains(this.clickWorldCoordinate)) {
        //     this.selection.selectedTile = null;
        //     return;
        // }

        // this.selection.selectedTile = this.worldGrid.findGridTile(this.clickWorldCoordinate);

        // if (this.selection.selectedTile) {
        //     this.selection.newSelection = true;
        // }
    }

    /**
     * @private
     */
    handlePanning() {

        if (this.userInput.leftMouseDown) {
            this.delta.x = this.userInput.mouseDeltaX;
            this.delta.y = this.userInput.mouseDeltaY;
        }
        else {
            // Decay
            this.delta.x *= Settings.input.panning.decayFactor;
            this.delta.y *= Settings.input.panning.decayFactor;

            // set delta xy to 0 if small enough
            if (Math.abs(this.delta.x) < 1) {
                this.delta.x = 0;
            }
            if (Math.abs(this.delta.y) < 1) {
                this.delta.y = 0;
            }

            // If we're not clicking, then we're hovering.
            //this.handleHover();
        }

        // deltaX/deltaY values are in screen coordinates. we need to convert them into world coords.
        if (this.delta.x !== 0 || this.delta.y !== 0) {

            //console.log('InputHandler.handlePanning() dx=' + this.delta.x + ' dy=' + this.delta.y);

            this.mapPanned = true;
            this.mapPannedTime = Date.now();
            this.projection.updateSpaceCenter(
                this.projection.screenToWorldDistance(-this.delta.x),
                this.projection.screenToWorldDistance(-this.delta.y)
            );

            // Indiciate that the player is now panning the canvas freely and that the game is not trying to keep
            // the character at the center.
            this.projection.stayCenteredOnCharacter = false; 
                      
            // If pan animation is active, we want to disable it or else it cancel our panning
            this.panAnimation.animating = false;
        }
        else {
            this.mapPanned = false;
        }
    }

    // /**
    //  * @private
    //  */
    // handleHover() {
    //     // this.screenCoordinate.set(this.userInput.mouseX, this.userInput.mouseY);

    //     // this.projection.screenToWorld(this.screenCoordinate, this.hoverWorldCoordinate);   

    //     // // // If the click is outside of the world grid, then ignore it.
    //     // // if (!this.worldGrid.contains(this.hoverWorldCoordinate)) {
    //     // //     this.selection.hoveredTile = null;
    //     // //     return;
    //     // // }

    //     // this.selection.hoveredTile = this.worldGrid.findGridTile(this.hoverWorldCoordinate);
    // }

    /**
     * @private
     */
    handleZoomInput() {
        // Handle mouse wheel input here since it is the same for piloting or panning.
        var mouseWheelMotion = this.userInput.mouseWheelMotion;
        if (mouseWheelMotion < 0) {
            this.projection.zoomIn();
        }
        else if (mouseWheelMotion > 0) {
            this.projection.zoomOut();
        }
    }

}